import type { ReactElement } from "react";
import { FormField } from "@playbookai/ui";

/** One labelled filter control.
 *
 * A thin wrapper over the design system's FormField rather than a hand-rolled
 * label + hint: FormField already owns the label/control association and puts
 * the hint in `aria-describedby` instead of the accessible NAME, which is the
 * distinction that matters here — concatenated, the control announces as
 * "Action membership_granted" rather than "Action". `content-start` keeps a
 * one-line field top-aligned with a two-line neighbour in the filter grid. */
export function FilterField({
  label,
  hint,
  children,
}: {
  label: string;
  hint: string;
  children: ReactElement;
}): ReactElement {
  return (
    <FormField label={label} hint={hint} className="content-start">
      {children}
    </FormField>
  );
}
